export default "__VITE_ASSET__GKIdsWHg__"